import { injectable } from 'inversify'
import { HttpClient, HttpStatusCode } from './http-client'

@injectable()
export class HttpClientMock extends HttpClient {
  public request(): Promise<{ statusCode: HttpStatusCode; data: unknown }> {
    return Promise.resolve({ statusCode: HttpStatusCode.CREATED, data: null })
  }
}
